const ISO_CODE_TO_SYMBOL_MAP = {
  CAD: '$',
  USD: '$',
  GBP: '£',
  EUR: '€',
};

export default ISO_CODE_TO_SYMBOL_MAP;



// WEBPACK FOOTER //
// ./src/utils/iso-code-to-symbol-map.js